import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';  // To handle routing and fetching the project by ID
import { API_BASE_URL } from '../../api';
import Sidebar from './Sidebar'
import Header from './Navbar'
import Footer from './Footer'
import Loader from './Loader';
import axios from 'axios';
import Select from 'react-select';
import { priceInWords } from '../../Helpers'
// import { convertToWords } from 'react-number-to-words';

const Edit_project = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    client_id: '',
    project_name: '',
    start_date: '',
    end_date: '',
    amount: '',
    status: 'onhold',
    package: '',
    remarks: '',
    agent: 'MEET',
    renewal_month: '1',
  });

  const [amountInWord, setAmountInWord] = useState([]);
  const [clients, setClients] = useState([]);
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
    user_id: localStorage.getItem('userId'),
  };

  useEffect(() => {

    const fetchClients = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/api/client`, { headers });
        setClients(data);
      } catch (error) {
        console.error('Error fetching clients:', error.response?.data || error.message);
      }
    };

    const fetchProject = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/api/project/${id}`, { headers });
        setFormData(data);
      } catch (error) {
        console.error('Error fetching project:', error.response?.data || error.message);
      }
    };
    fetchClients();
    fetchProject();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.put(
        `${API_BASE_URL}/api/project/${id}`,
        formData,
        { headers }
      );

      Swal.fire({
        icon: 'success',
        title: 'Project Updated',
        text: 'The project has been updated successfully!',
      });
      navigate('/dashboard/project');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Failed to update project: ${error.response?.data?.message || error.message}`,
      });
    }
  };
  // 
  const clientOptions = useMemo(
    () =>
      clients.map((client) => ({
        value: client.id,
        label: client.full_name,
      })),
    [clients]
  );

  // Handler for react-select components
  const handleSelectChange = (selectedOption, actionMeta) => {
    setFormData((prevData) => ({
      ...prevData,
      [actionMeta.name]: selectedOption ? selectedOption.value : '',
    }));
  };

  // Handler for standard input fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const numberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setAmountInWord(priceInWords(value));
    console.log(priceInWords(value));
    // amountinword.html()
  };

  // Create selected option object for the client select
  const selectedClientOption = clientOptions.find(
    (option) => option.value === formData.client_id
  ) || null;


  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <main id='main' className='main'>
        <section className='section'>
          <div className='row'>
            <div className="col-12">
              <div className="">
                <Loader />
                <div className="content">
                  <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2 text-start">
                      <div className="pagetitle">
                        <h1>Edit Project</h1>
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                              <a href="#">Home</a>
                            </li>
                            <li className="breadcrumb-item active">Edit Project</li>
                          </ol>
                        </nav>
                      </div>
                    </div>

                  </div>
                  <div className="card text-start">
                    <div className="card-body">
                      <div className="">

                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Client Name</label>
                                <Select
                                  options={clientOptions}
                                  name="client_id"
                                  value={clientOptions.find((option) => option.value === formData.client_id)}
                                  onChange={selectedClientOption}
                                  placeholder="Select a Client"
                                  isClearable
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Project Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="project_name"
                                  value={formData.project_name}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-6 mb-3">
                              <label className="form-label">Start Date</label>
                              <input
                                type="date"
                                name="start_date"
                                value={formData.start_date}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col-6 mb-3">
                              <label className="form-label">End Date</label>
                              <input
                                type="date"
                                name="end_date"
                                value={formData.end_date}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              />
                            </div>
                            <div className="col-6 mb-3">
                              <label className="form-label">Amount</label>
                              <input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={numberChange}
                                className="form-control"
                                required
                              />
                              <span id="amountinword">{amountInWord}</span>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Status</label>
                                <select
                                  className="form-control"
                                  name="status"
                                  value={formData.status}
                                  onChange={handleInputChange}
                                >
                                  <option value="pending">Pending</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                  <option value="onhold">On Hold</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">Select Agent</label>

                                <select
                                  className="form-control"
                                  name="agent"
                                  value={formData.agent}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Agent</option>
                                  <option value="MEET">Meet</option>
                                  <option value="BRIJESH">Brijesh</option>
                                  <option value="NISHANTSIR">Nishant Sir</option>
                                  <option value="CHIRAG">Chirag</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-6 mb-3">
                              <label className="form-label">Renewal Month</label>
                              <input
                                type="number"
                                name="renewal_month"
                                value={formData.renewal_month}
                                onChange={handleInputChange}
                                className="form-control"
                                required
                              />
                            </div>

                            <div className="mb-3">
                              <label className="form-label">Package</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                name="package"
                                value={formData.package}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Remarks</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                          </div>

                          <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-outline-light border me-2" onClick={() => navigate('/dashboard/project')}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Save Changes</button>
                          </div>
                        </form>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />







    </div>
  )
}

export default Edit_project
